import {Strenger} from "../tjenester/Strenger";
import _ from "lodash";

export function foersteOrdForInjisering() {
    return [Strenger.regNavn, foersteOrd];
}

export function foersteOrd(strenger: Strenger): Function {
    return function (tekst: string) {
        if (!_.isString(tekst)) return tekst;
        return strenger.førsteOrd(tekst);
    };
}

